import { createContext, useEffect, useState } from 'react';
import { Alert, IAlertsContext } from './Models/Alerts';
import { useLocalStorage } from 'Utilities/UseStorage';

const initialState: IAlertsContext = {
  alerts: [],
  getAlerts: () => {},
  dismiss: () => {},
};

export const AlertsContext = createContext(initialState);

export function AlertsContextProvider({ children }: { children: React.ReactNode }) {
  const [dismissed, setDismissed] = useLocalStorage<string[]>('dismissed_alerts', [], undefined);
  const [alerts, setAlerts] = useState<Alert[]>();
  const [sending, setSending] = useState<boolean>(false);

  const getAlerts = async () => {
    if (sending || alerts) return;
    setSending(true);
    let res = await fetch('/api/sitecore/NowNavigationAsync/GetAlerts');
    let items: Alert[] | null = await res.json();
    setSending(false);
    if (items) setAlerts(items.filter((alert) => !dismissed?.includes(alert.Id)));
    else setAlerts([]);
  };

  const setDismissedAlert = (alertId: string) => {
    setDismissed({ data: [...(dismissed ?? []).filter((x) => x != alertId), alertId] });
  };

  useEffect(() => {
    if (alerts?.find((alert: Alert) => dismissed?.includes(alert.Id)))
      setAlerts((alerts) => alerts?.filter((alert) => !dismissed?.includes(alert.Id)) ?? []);
  }, [alerts, dismissed, dismissed]);

  let shared: IAlertsContext = {
    alerts: alerts,
    getAlerts: () => getAlerts(),
    /* dismissing an alert from the mailbox should dismiss any corresponding banner alert but not vice versa */
    dismiss: (id: string) => setDismissedAlert(id),
  };

  return <AlertsContext.Provider value={shared}>{children}</AlertsContext.Provider>;
}
